import { useEffect, useState } from "react";

import dayjs from "dayjs";
import { useNavigate, useParams } from "react-router-dom";

import { Button } from "@mui/material";
import { PageContainer } from "@/features/ui";

import { OutletRoleEnum } from "@/features/outlets";
import { SalesDownPaymentForm } from "@/features/sales-down-payments";
import { apiOutletClient, getErrorMessage } from "@/features/shared";
import { CenteredLoading, useSnackbar } from "@/features/ui";

export const EditSalesDownPayment = () => {
  const { referenceNumber } = useParams();
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(true);
  const [defaultValues, setDefaultValues] = useState(null);

  useEffect(() => {
    const fetchSalesDownPayment = async () => {
      setIsLoading(true);
      try {
        const {
          data: { data },
        } = await apiOutletClient.get(
          `sales-down-payments/${referenceNumber}`,
          {
            params: {
              withBuyer: true,
              withSeller: true,
              withPaymentTerm: true,
              withSalesOrder: true,
            },
          },
        );

        setDefaultValues({
          seller: data.seller,
          buyer: data.buyer,
          buyerableType:
            data.seller?.role === OutletRoleEnum.HUB ? "OUTLET" : "CUSTOMER",
          salesOrder: data.salesOrder,
          transactionDate: dayjs(data.transactionDate),
          amount: data.amount ?? data.grandTotal,
          paymentTerm: data.paymentTerm,
          note: data.note ?? "",
        });
      } catch (error) {
        showSnackbar(
          getErrorMessage(error, "Gagal memperbarui uang muka penjualan"),
        );
      } finally {
        setIsLoading(false);
      }
    };
    fetchSalesDownPayment();
  }, [referenceNumber, showSnackbar]);

  const handleSubmit = async (formData) => {
    try {
      const { sellerId, transactionDate, amount, paymentTermId, note } =
        formData;

      await apiOutletClient.patch(
        `sales-down-payments/${referenceNumber}`,
        { transactionDate, amount, paymentTermId, note },
        {
          headers: {
            "Outlet-Id": sellerId,
          },
        },
      );
      navigate(-1);
    } catch (error) {
      const errorMessage =
        getErrorMessage(error, "Gagal memperbarui uang muka penjualan");
      showSnackbar(errorMessage);
    }
  };

  if (!defaultValues && isLoading) {
    return <CenteredLoading />;
  }

  return (
    <PageContainer
      maxWidth="xl"
      title="Ubah Uang Muka Penjualan"
      breadcrumbs={[
        {
          title: "Uang Muka Penjualan",
          path: "/sales/sales-down-payments",
        },
        {
          title: referenceNumber,
          path: `/sales/sales-down-payments/${referenceNumber}`,
        },
        { title: "Ubah" },
      ]}
    >
      <SalesDownPaymentForm
        editMode
        isLoading={isLoading}
        defaultValues={defaultValues}
        onSubmit={handleSubmit}
        renderActionButton={({ isSubmitting }) => (
          <Button type="submit" variant="contained" loading={isSubmitting}>
            Simpan
          </Button>
        )}
      />
    </PageContainer>
  );
};
